import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service'
import { Router, ActivatedRoute} from '@angular/router';
import { Proflie } from '../../../profile';

@Component({
  selector: 'app-massage-dashboard',
  templateUrl: './message-dashboard.component.html',
  styleUrls: ['./message-dashboard.component.scss']
})
export class MessageDashboardComponent implements OnInit {

  isUserLogin: boolean
  messages: Object
  total: any
  public errorMsg: any

  constructor(private userApi: ApiService,
    private router:Router,
    private route: ActivatedRoute) {       
      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
    }

  ngOnInit(): void {

    this.userApi.getMessage('all').subscribe(
      data => {
        this.messages = data;
        // console.log(this.messages);
        this.total = Object.keys(data).length;
      },
      error => this.errorMsg = error
    );

  }

  goMain() {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  goWeb() {
    this.router.navigate(['/user/dashboard/web'], {relativeTo: this.route});
  }

  goPhotogrphy() {
    this.router.navigate(['/user/dashboard/photography'], {relativeTo: this.route});
  }

  goMessage() {
    this.router.navigate(['/user/dashboard/message'], {relativeTo: this.route});
  }

  goUser() {
    this.router.navigate(['/user/dashboard/user'], {relativeTo: this.route});
  }

  deleteItem(item: Proflie): void{
    this.userApi.deleteItem(item)
      .subscribe(data => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/user/dashboard/message']);
      })
  }

}
